import React from "react";
import axios from "axios";
import { useState, useEffect, useMemo } from "react";
import MaterialReactTable from "material-react-table";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faPencil,  faTrashAlt } from '../../../node_modules/@fortawesome/free-solid-svg-icons/index';

const SchemePMFBY = () => {
  const [value, setvalue] = useState("");
  const [schemePMFBYData, setSchemePMFBYData] = useState([]);
  const [flag, setFlag] = useState(false);
  const [schemePMFBYValue, setSchemePMFBYValue] = useState("");
  const [schemePMFBYShortValue, setSchemePMFBYShortValue] = useState("");
  const [deleteCode, setDeleteCode] = useState({});
  const [editCode, setEditCode] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const result = await axios(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/PMFBYScheme`
    );
    setSchemePMFBYData(result.data.dataContent);
  };

  useEffect(() => {
    if (flag === true) {
      fetchData();
    }
  }, [flag]);

  const columns = useMemo(
    () => [
      {
        header: "S.No",
        Cell: (cell) => Number(cell.row.id) + 1,
      },
      {
        accessorKey: "schemeName",
        header: "Scheme Name",
      },
      {
        accessorKey: "shortName",
        header: "Scheme Short Name",
      },
      {
        accessorKey: "visibility",
        header: "Visibility",
      },
      {
        accessor: "",
        header: "Actions",
        Cell: (cell) => (
          <>
            <i
              className="btn text-primary"
              type="button"
              onClick={() => handleEditSchemePMFBY(cell.row.original)}
            >
              <FontAwesomeIcon icon={faPencil} />
            </i>
            <i
              className="btn text-danger"
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#myDelete"
              onClick={() =>
                setDeleteCode({
                  schemeCode: cell.row.original.schemeCode,
                })
              }
            >
              {" "}
              <FontAwesomeIcon icon={faTrashAlt} />
            </i>
          </>
        ),
      },
    ],
    []
  );

  function removed() {
    var mpopup = document.getElementById("mpopupBox");
    mpopup.style.display = "none";
    setSchemePMFBYValue("");
    setSchemePMFBYShortValue("");
  }

  function removedAdd() {
    var mpopup = document.getElementById("AddNewSchemePMFBY");
    mpopup.style.display = "none";
    setSchemePMFBYValue("");
    setSchemePMFBYShortValue("");
  }



  function handleEditSchemePMFBY(value) {
    document.getElementById("schemePMFBYEdit").value = value.schemeName;
    document.getElementById("schemePMFBYShortEdit").value = value.shortName;

    // localUserTypeName = value.userTypeName
    // document.getElementById("userTypeEdit").defaultValue= ""
    // document.getElementById("userTypeEdit").defaultValue = value.userTypeName;
    setEditCode({
      "schemeCode":  value.schemeCode,
      "visibility": value.visibility
    
    });

    
    setSchemePMFBYValue(document.getElementById("schemePMFBYEdit").value)
    setSchemePMFBYShortValue(document.getElementById("schemePMFBYShortEdit").value)

    //   setUserTypeValue(value.seasonName)
    var x = document.createElement("a");
    x.id = "mpopupLink";
    var mpopup = document.getElementById("mpopupBox");
    mpopup.style.display = "block";
  }

  function AddNewSchemePMFBY() {
    if (schemePMFBYValue && schemePMFBYShortValue) {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        createdByUC: localStorage.getItem("userCodeGlobal"),
        schemeName: schemePMFBYValue,
        shortName: schemePMFBYShortValue
      
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/PMFBYScheme`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          alert(JSON.parse(result).message);
          //   $('#addNewBtn').on('click', function () {
          // $('#addNewUserType').modal('hide');
          //  })
          if (JSON.parse(result).success === true) {
            // $('#addNewBtn').on('click', function () {
            // $('#addNewUserType').modal('hide');
            // })

            setFlag(true);
            setSchemePMFBYValue("");
            setSchemePMFBYShortValue("");
            removedAdd()
          }
        })
        .catch((error) => console.log("error", error));
    } else {
      alert("Enter All Fields");
    }
  }

  function deleteData(value) {

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify(deleteCode);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/PMFBYScheme`, requestOptions)
        .then(response => response.text())
        .then(result => {
            if (JSON.parse(result).success === true) {
                fetchData()

            }
        })
        .catch(error => console.log('error', error));
}

function EditSchemePMFBY() {
    if (schemePMFBYValue && schemePMFBYShortValue) {
       
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({  

        "modifiedByUC": localStorage.getItem("userCodeGlobal"),
        "schemeCode": editCode.schemeCode,
        "schemeName": schemePMFBYValue,
        "shortName": schemePMFBYShortValue,
        "visibility": "Y" 
    });

    var requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/PMFBYScheme`, requestOptions)
        .then(response => response.text())
        .then(result => {
            alert(JSON.parse(result).message)
            if (JSON.parse(result).success === true) {
                setSchemePMFBYValue("")
                setSchemePMFBYShortValue("")
                fetchData()
                removed()


            }
        }
        )
        .catch(error => console.log('error', error));
    } else {
        alert("Enter All Fields");
      }
       
}

function handleschemePMFBYValue(value) {
    const valueFinal = value.replace(/[^a-z0-9 ]/gi, "");
    document.getElementById("schemePMFBYEdit").value = valueFinal;
    setSchemePMFBYValue(valueFinal)
}

function handleschemePMFBYShortValue(value) {
    const valueFinal = value.replace(/[^a-z0-9 ]/gi, "");
    document.getElementById("schemePMFBYShortEdit").value = valueFinal;
    setSchemePMFBYShortValue(valueFinal)
}

function handleAddNewData() {
    setSchemePMFBYValue("");
    setSchemePMFBYShortValue("");
    setFlag(false)
}

  return (
    <>
      <main id="main" className="main">
      <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
         
          <nav>
          <h1>Scheme PMFBY</h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">Master</li>
              <li className="breadcrumb-item active">Scheme PMFBY</li>
            </ol>
          </nav>
          <button
            type="button"
            className="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target="#AddNewSchemePMFBY"
            onClick={() => handleAddNewData()}
          >
            Add New
          </button>
        </div>
        <section className="section">
          <div className="row justify-content-lg-center">
            <div className="col-lg-12 ">
              <div className="card">
                <MaterialReactTable
                  columns={columns}
                  data={schemePMFBYData}
                  enableColumnOrdering
                  enablePagination={true}
                />
              </div>
            </div>

            <div className="col-lg-6"></div>
          </div>
          <div className="modal" id="AddNewSchemePMFBY">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                <label for="add_season" className="form-label">
                    Add New Scheme PMFBY
                  </label>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                  >
                    X
                  </button>
                </div>

                <div className="modal-body">
                <label for="add_season" className="form-label">
                    Scheme Name
                  </label>
           
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Scheme Name"
                    onChange={(e) => handleschemePMFBYValue(e.target.value)}
                    value={schemePMFBYValue}
                    maxLength={50}
                  />
                  <br/>
                  <label for="add_season" className="form-label">
                    Scheme Short Name
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Scheme Short Name "
                    onChange={(e) => handleschemePMFBYShortValue(e.target.value)}
                    value={schemePMFBYShortValue}
                    maxLength={50}
                  />
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-success"
                    id="addNewBtn"
                    // data-bs-dismiss="modal"
                    onClick={AddNewSchemePMFBY}
                  >
                    Add
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div id="mpopupBox" className="modal">
            <div className="modal-content">
              <div className="modal-header">
              <label for="edit_season" className="form-label">
                 <h2>Edit Scheme PMFBY</h2> 
                </label>
              </div>
              <div className="madal-body" id="modal-content">
               
                <label for="add_season" className="form-label">
                    Scheme Name
                  </label>

                <input
                  type="text"
                  className="form-control"
                  id="schemePMFBYEdit"
                  placeholder="Scheme Name "
                  onChange={(e) => handleschemePMFBYValue(e.target.value)}
                  maxLength={50}
                />
                <br/>
                <label for="add_season" className="form-label">
                    Scheme Short Name
                  </label>
                <input
                  type="text"
                  className="form-control"
                  id="schemePMFBYShortEdit"
                  placeholder="Scheme Short Name "
                  onChange={(e) => handleschemePMFBYShortValue(e.target.value)}
                  maxLength={50}
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  data-bs-dismiss="modal"
                  onClick={EditSchemePMFBY}
                >
                  Add
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={removed}
                >
                  Close
                </button>
              </div>
            </div>
          </div>

          <div className="modal" id="myDelete">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                  >
                    X
                  </button>
                </div>

                <div className="modal-body">
                  <p>Are you sure you want to delete this item?</p>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-success"
                    data-bs-dismiss="modal"
                    onClick={deleteData}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default SchemePMFBY;
